import {once} from './core.js';

const DEFAULT_THRESHOLD = 200;
const INTERACTIVE_SELECTOR = 'a, button, input, select, textarea, label, [role="button"], [contenteditable="true"]';

function findToolbar(root) {
	if (root.matches?.('[data-sticky-top-info]')) {
		return root;
	}
	return root.querySelector?.('[data-sticky-top-info]');
}

export function init(root = document) {
	const toolbar = findToolbar(root);
	if (!toolbar || !once(toolbar, 'sticky-top-info')) {
		return;
	}

	const threshold = Number.parseInt(toolbar.dataset.scrollThreshold || '', 10) || DEFAULT_THRESHOLD;
	const toTop = toolbar.querySelector('[data-scroll-to-top]');
	let framePending = false;
	const scrollToTop = () => {
		const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		window.scrollTo({top: 0, behavior: reducedMotion ? 'auto' : 'smooth'});
	};

	const sync = () => {
		framePending = false;
		toolbar.hidden = window.scrollY <= threshold;
	};

	const scheduleSync = () => {
		if (framePending) {
			return;
		}
		framePending = true;
		window.requestAnimationFrame(sync);
	};

	window.addEventListener('scroll', scheduleSync, {passive: true});
	toTop?.addEventListener('click', scrollToTop);
	toolbar.addEventListener('click', (event) => {
		if (event.target instanceof Element && event.target.closest(INTERACTIVE_SELECTOR)) {
			return;
		}
		scrollToTop();
	});
	sync();
}
